import React from "react";
import addDays from "date-fns/addDays";
import axios, { AxiosResponse } from "axios";
import moment from 'moment';
import { AlertColor, Button, Checkbox, FormControlLabel, IconButton, InputBase, Link, Paper, TextField, useMediaQuery} from "@mui/material";
import { Add, AddCard, ChangeCircle, Replay, Search } from "@mui/icons-material";
import { DataGridPro, GridCellParams, GridColumns, GridSelectionModel, GridToolbarContainer } from '@mui/x-data-grid-pro';
import Title from "../../component/Title";
import { BaseControl, DatePickerControl, DropDownComboControl, GenericFilter } from "../../component/GenericFilter";
import { globalTheme } from "../../../common/theme";
import { useConstructor } from "../../../common/UseConstructor";
import { InvoiceFilter } from "../../../models/classes/InvoiceFilter";
import { CustomTablePagination } from "../../component/CustomPagination";
import { Invoice } from "./InvoiceAccessories";
import { GetInvoiceRegion, InvoiceSingle, InvoiceSingleHandle } from "./InvoiceSingle";
import { useAppSelector } from "../../../common/hooks";
import { RootState } from "../../../common/Store";
import { CommonProps } from "../../component/MainContents";
import { BranchInfo } from "../branches/BranchAccessories";
import { Pad } from "../../../common/Formatter";
import { getDefaultRegion, renewToken } from "../../../services/AuthService";
import { SnackBarMessage, SnackBarMessageProps } from "../../component/SnackBarMessage";
import { PackingListSingle, PackingListSingleHandle } from "../packing-lists/PackingListSingle";
import { PackingList } from "../packing-lists/PackingListAccessories";
import { useNavigate } from "react-router-dom";
import { OpenMode } from "../../../common/Enums";

export function InvoiceList(props: CommonProps) {
	const [loading, setLoading] = React.useState(true);
	const [hasError, setHasError] = React.useState(false);

    const isDebug = useAppSelector((state: RootState) => state.menuToggle.debugMode);

	const singleModalRef = React.useRef<InvoiceSingleHandle>(null);

	const singlePackingListModalRef = React.useRef<PackingListSingleHandle>(null);

	const navigate = useNavigate();

    const style = { ...globalTheme() };

    const tinyScreen = useMediaQuery('(max-width:1366px)');
    const smallScreen = useMediaQuery('(max-width:1920px)');
    const normalScreen = useMediaQuery('(max-width:2560px)');

    const checkboxLabelStyle = {
        border: "none",
        width: '180px',
        height: '28px',
        paddingTop: 0,
        paddingLeft: 8
    };
	const [isProforma, setIsProforma] = React.useState<boolean>(false);

	const [showConvertButton, setShowConvertButton] = React.useState<string>("none");
      
    const [controls, setControls] = React.useState<BaseControl[]>([]); //For filtering

	const [branchInfo, setBranchInfo] = React.useState<BranchInfo[]>([]);

    const [searchData, setSearchData] = React.useState<any>({
        contains: true,
        searchText: "",
        customer: 0,
        createdFrom: addDays(new Date(), -60),
        createdTo: new Date(),
		sales: 0,
        region: "ALL",
        pageSize: 15,
    });

    //Dialogs and snacks
    const [snackSettings, setSnackSettings] =
      React.useState<SnackBarMessageProps>({
        open: false,
        message: "",
        subMessage: "",
        severity: undefined,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });

    function showSnackBar(message: string, subMessage: string, colour?: AlertColor) {
      setSnackSettings({
        open: true,
        message: message,
        subMessage: subMessage,
        severity: colour,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });
    }

	function LoadData(isProforma: boolean) {
		setLoading(true);
        let filter = new InvoiceFilter({
			InvoiceNo: searchData.searchText,
			CustomerID: searchData.customer % 100000,
			From: moment(searchData.createdFrom).format(),
			To: moment(searchData.createdTo).format(),
			StaffID: Number(searchData.sales),
			Region: searchData.region,
			IsProforma: isProforma,
			Reader: ""
		});

		axios.post<Invoice[]>('Api/V1/Invoice/Search', filter, {
			headers: {
				'Content-Encoding': 'gzip'
			}
		})
			.then((result) => {
				result.data.forEach(i => {
					i.id = i.invoiceNo;
				});

				setGridData(result.data.sort((a, b) => {
					if (a.createDate > b.createDate) { return -1; }
					if (a.createDate < b.createDate) { return 1; }
					if (a.createDate === b.createDate)
					{
						if (a.invoiceNo > b.invoiceNo) { return -1; }
						if (a.invoiceNo < b.invoiceNo) { return 1; }
					}
					return 0;					
				}))
				setAllData(result.data.sort((a, b) => {
					if (a.createDate > b.createDate) { return -1; }
					if (a.createDate < b.createDate) { return 1; }
					if (a.createDate === b.createDate)
					{
						if (a.invoiceNo > b.invoiceNo) { return -1; }
						if (a.invoiceNo < b.invoiceNo) { return 1; }
					}
					return 0;					
				}));
				setLoading(false);
			},
				(error) => {
					setGridData([]);
					setAllData([]);
					setLoading(false);
					console.log(error);
					showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
				}
			)
			.catch((error) => {
				console.log(error);
				showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
			});
	}


	function LoadBranchInfo() {
		axios.get<any[]>(`Api/V1/Branch`, {
			headers: {
				'Content-Encoding': 'gzip'
			}
		})
			.then((result) => {
				setBranchInfo(result.data);
			},
				(error) => {
					setBranchInfo([]);
					console.log(error);
					showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
				}
			)
			.catch((error) => {
				console.log(error);
				showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
			});
	}

	useConstructor(() => Initialise())
    function Initialise() {
        setLoading(true);
		renewToken();

		setControls([
			{
				key: 'createdFrom',
				title: 'Created From',
				dateValue: addDays(new Date(), -7)
			} as DatePickerControl,
			{
				key: 'createdTo',
				title: 'Created To',
				dateValue: new Date()
			} as DatePickerControl,
			{
				key: 'customer',
				title: 'Customer',
				dropdownOptions: props.customers
			} as DropDownComboControl,
			{
				key: 'region',
				title: 'Region',
				dropdownOptions: props.regions
			} as DropDownComboControl,
			{
				key: 'sales',
				title: 'Sales',
				dropdownOptions: props.sales
			} as DropDownComboControl
		]);
		LoadBranchInfo();
		LoadData(isProforma);
    }

	//Grid columns
	const columns: GridColumns = [
		{
			field: 'invoiceNo', headerName: 'Invoice No', flex: 1, renderCell: (params: GridCellParams) => (
				<Link
					href="#"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						EditObject(params.id.toString());
					}}
					color="inherit"
					underline="hover">
					<strong>
						{params.value}
					</strong>
				</Link>
			)
		},
		{ field: 'customerName', headerName: 'Customer', flex: 4, type: 'string' },
		{ field: 'createDate', headerName: 'Create Date', flex: 1, 
			renderCell: (params: GridCellParams) => (
				<TextField variant="standard" value={moment(params.value).format('YYYY/MM/DD')} InputProps={{ disableUnderline: true }}/>
			)
		},
		{ field: 'staff', headerName: 'Sales', flex: 1, type: 'string' },
		{ field: 'createdBy', headerName: 'Created By', flex: 1, type: 'string' },
	];

	const [gridData, setGridData] = React.useState<Invoice[]>([]);
    const [allData, setAllData] = React.useState<Invoice[]>([]);
	const selectedData = React.useRef<Invoice[]>([]);

	function CustomToolbar() {
		return (
			<GridToolbarContainer style={{ display: 'flex' }}>
				<Button variant="contained" size="small" color="secondary" style={{ margin: "2px" }} startIcon={<Add />} onClick={() => NewObject()}>Create</Button>
				<div style={{ width: 10 }}></div>
				<Button variant="contained" size="small" color="secondary" style={{ margin: "2px" }} startIcon={<AddCard />} onClick={() => CreatePackingList()}>Create P/L</Button>
				<div style={{ width: 10 }}></div>
				<FormControlLabel
					style={checkboxLabelStyle}
					control={
					<Checkbox checked={isProforma} onChange={(e) => {
						setIsProforma(!isProforma);
						LoadData(!isProforma);
						if (!isProforma && selectedData.current.length === 1)
							setShowConvertButton("flex");
						else
							setShowConvertButton("none");	
					}} />
					}
					label="Proforma Invoice"
            	/>				
				<div style={{ width: 10 }}></div>
				<Button variant="contained" size="small" color="secondary" style={{ margin: "2px", display: showConvertButton }} startIcon={<ChangeCircle />} onClick={() => ConvertObject()}>Convert</Button>
				<div style={{ flexGrow: 1 }}></div>
				<Button variant="contained" size="small" color="secondary" style={{ margin: "2px" }} startIcon={<Replay />} onClick={() => Initialise()}>Reload</Button>
			</GridToolbarContainer>
		);
	}

	function NewObject() {
		axios.get<BranchInfo[]>(`Api/V1/Branch`, {
			headers: {
				'Content-Encoding': 'gzip'
			}
		})
			.then((result) => {
				setBranchInfo(result.data);

				let defaultBranch: BranchInfo | undefined = result.data.find(b => b.region === getDefaultRegion());
				if (defaultBranch)
				{
					let invoiceNumber = defaultBranch.invoiceNo;
					if (defaultBranch.invoiceMonth != new Date().getMonth() + 1)
					{
						invoiceNumber = defaultBranch.nextMonthInvoiceNo;
					}
					let invoice: Invoice = {
						id: "",
						invoiceNo: isProforma ? "PI" + defaultBranch.region : "ME" + defaultBranch.region + (new Date().getFullYear()) + "/" + Pad(new Date().getMonth() + 1, 2) + Pad(invoiceNumber, 3),
						revisionNo: "0",
						custLangID: 1,
						customerID: 0,
						customerName: "",
						languageID: 1,
						createDate: moment(new Date()).format(),
						staffID: 0,
						staff: "",
						createdBy: "",
						attention: "",
						phone: "",
						fax: "",
						deliveryTo: "C.I.F. HK ",
						paymentTerm: "30 days after delivery",
						currency: "JPY",
						exRate: 1,
						plRemark1: "注意: 如果貴公司須要由日本--香港--中國, 香港到中國的運貨, 將由貴公司負責, 但不須要做報關, 敬希垂注!",
						plRemark2: "The price quoted is net price per piece and will be valid for 30 days only.",
						plRemark3: "If order amount is less than RMB10000, please pick up the goods at Musashi Eng. office. 如订单金额少於人民幣一万元, 请自行派人到武藏办公室取货。",
						invoiceItems: [],
						loginName: "",
						status: "ACT",
						arrivalDate: "",
						deliveryBy: "",
						bankName: "",
						bankAddress: "",
						bankAccount: "",
						shipAttn: "",
						deliveryContact: "",
						deliveryAddress: "",
						deliveryPhone: "",
						deliveryFax: "",
						carton: "",
						reportTotal: "",
						lessAmount: 0.0,
						lessPercent: 0.0,
						remark: "",
						packingListPONo: "",
						updatedBy: "",
						isProforma: isProforma,
						address: ""
					}
					singleModalRef.current?.Initialise(OpenMode.NEW, invoice, isProforma);
				}
			},
				(error) => {
					setBranchInfo([]);
					console.log(error);
					showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
				}
			)
			.catch((error) => {
				console.log(error);
				showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
			});
	}

	function EditObject(invoiceNo: string) {
        setLoading(true);
		axios.get<Invoice>('Api/V1/Invoice/' + invoiceNo.replace(/\//g, "%2F"), {
			headers: {
			  'Content-Encoding': 'gzip'
			}
		  })
			.then((result) => {
				result.data.createdBy=''; //createBy cannot be null when save
				result.data.status='ACT'; //status cannot be null when save
				singleModalRef.current?.Initialise(OpenMode.EDIT, result.data, isProforma);
				setLoading(false);
			},
			  (error) => {
				setLoading(false);
				console.log(error);
				showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
			}
			)
			.catch((error) => {
			  setLoading(false);
			  console.log(error);
			  showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
			});
	}

	function ConvertObject() {
		if (selectedData.current.length != 1)
		{
			showSnackBar("Please select one row to convert.", "", "warning");
			return;
		}
		
		let invoiceNo = selectedData.current[0].invoiceNo;

		setLoading(true);

		axios.all([
			axios.get(`Api/V1/Invoice/` + invoiceNo, {
				headers: {
				  'Content-Encoding': 'gzip'
				}
			}),                
			axios.get<BranchInfo[]>(`Api/V1/Branch`, {
				headers: {
					'Content-Encoding': 'gzip'
				}
			})
		]).then(axios.spread((...responses) => {
			const invoiceResult: AxiosResponse<Invoice> = responses[0];
			const branchInfoResult: AxiosResponse<BranchInfo[]> = responses[1];

			let branch: BranchInfo | undefined = branchInfoResult.data.find(b => b.region === GetInvoiceRegion(invoiceNo));
			if (branch)
			{
				let invoiceNo = "ME" + branch.region + (new Date().getFullYear()) + "/" + Pad(new Date().getMonth() + 1, 2) + Pad(branch.invoiceNo, 3);
				invoiceResult.data.invoiceNo = invoiceNo;
				invoiceResult.data.createDate = moment(new Date()).format();
				invoiceResult.data.createdBy = ''; //createBy cannot be null when save
				invoiceResult.data.status = 'ACT'; //status cannot be null when save
				invoiceResult.data.isProforma = false;
				invoiceResult.data.invoiceItems.forEach(x => x.invoiceNo = invoiceNo);
				singleModalRef.current?.Initialise(OpenMode.COPY, invoiceResult.data, false);
			}			
			setLoading(false);
		})).catch((error) => {
			setHasError(true);
			setLoading(false);
			showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
		});
	}

	function CreatePackingList() {
		if (selectedData.current.length == 0)
		{
			showSnackBar("Please select at least one row to create packing list.", "", "warning");
			return;
		}
		if (selectedData.current.length > 1)
		{
			var customerId = selectedData.current[0].customerID;
			let invoiceOfDifferentCustomer = selectedData.current.find(x => x.customerID != customerId);
			if (invoiceOfDifferentCustomer)
			{
				showSnackBar("Please select invoices of the same customer to create invoice.", "", "warning");
				return;
			}
		}

		let invoiceNo = selectedData.current[0].invoiceNo;
		let invoiceNos = Array.prototype.map.call(selectedData.current, q => q.invoiceNo).toString();

		setLoading(true);
        const params = { invoiceNos:  invoiceNos};

		axios.all([
			axios.get(`Api/V1/PackingList/CreateByInvoice`, {
				params,
				headers: {
				  'Content-Encoding': 'gzip'
				}
			}),                
			axios.get<BranchInfo[]>(`Api/V1/Branch`, {
				headers: {
					'Content-Encoding': 'gzip'
				}
			})
		]).then(axios.spread((...responses) => {
			const plResult: AxiosResponse<PackingList> = responses[0];
			const branchInfoResult: AxiosResponse<BranchInfo[]> = responses[1];

			let branch: BranchInfo | undefined = branchInfoResult.data.find(b => b.region === GetInvoiceRegion(invoiceNo));
			if (branch)
			{
				plResult.data.packingListNo = "PL" + branch.japanYear + branch.region + Pad(branch.plNo, 5);
				plResult.data.createDate = moment(new Date()).format();
				plResult.data.createdBy=''; //createBy cannot be null when save
				plResult.data.status='ACT'; //status cannot be null when save
				singlePackingListModalRef.current?.Initialise(OpenMode.COPY, plResult.data);
			}				
			setLoading(false);
		})).catch((error) => {
			setHasError(true);
			setLoading(false);
			showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
		});
	}

    function DoSearch(event: React.FormEvent<any>) {
		if (event)
        	event.preventDefault();

		LoadData(isProforma);
    }
  
	function OnSelectionChanged(model: GridSelectionModel) {
		const ids = new Set(model);
		if (model.length === 1 && isProforma) {
			setShowConvertButton("flex");
		} 
		else {
			setShowConvertButton("none");
		}
		const selectedRows = gridData.filter((row) => ids.has(row.invoiceNo));
		selectedData.current = selectedRows;
	}

    return (
        <div className={style.PageMain}>
			<Title pageTitle="Invoice List" />
			<GenericFilter controls={controls} searchData={searchData} setSearchData={setSearchData} doSearch={DoSearch} searchBoxLabel="Invoice No" />
			<div className={style.PageContent}>
				<DataGridPro
					rows={gridData}
					columns={columns}
					pageSize={searchData.pageSize}
					onPageSizeChange={(pageSize) => setSearchData({ ...searchData, pageSize: pageSize })}
					pagination
					rowsPerPageOptions={[15, 30, 50, 100]}
					loading={loading}
					checkboxSelection
					components={{
						Toolbar: CustomToolbar,
						Footer: CustomTablePagination
					}}
					componentsProps={{
						footer: { rowsPerPageOptions: [15, 30, 50, 100] }
					}}
					onSelectionModelChange={(selectionModel) => OnSelectionChanged(selectionModel)}
					headerHeight={tinyScreen ? 30 : (smallScreen ? 34 : 38)}
					rowHeight={tinyScreen ? 22 : (smallScreen ? 28 : 34)}
				/>
			</div>

			<InvoiceSingle
				ref={singleModalRef}
				customers={props.customers} 
				endUsers={props.endUsers} 
				regions={props.regions}
				sales={props.sales} 
				deliveryMethods={props.deliveryMethods}
				paymentTerms={props.paymentTerms}
				currencies={props.currencies}
				onClose={(saved: boolean, invoice: Invoice) => {
					LoadData(invoice.isProforma);
					setIsProforma(invoice.isProforma);
				}} 
			/>

			<PackingListSingle
				ref={singlePackingListModalRef}
				customers={props.customers} 
				endUsers={props.endUsers} 
				regions={props.regions}
				sales={props.sales} 
				deliveryMethods={props.deliveryMethods}
				paymentTerms={props.paymentTerms}
				currencies={props.currencies}
				onClose={(saved: boolean, packingList: PackingList) => {
					if (saved) {
						navigate("/app/packinglist");
					}
				} } 
			/>

			<SnackBarMessage {...snackSettings} />

        </div>
    );
}

